<!--
 * @Author: zxf
 * @Date: 2022-07-26 22:24:00
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 16:30:05
 * @Description: 检测点信息查看
-->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-80 o-dialog--lg-60 o-dialog--xl-50 o-dialog-h--85"
    title="检测点信息查看"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <el-form
      ref="fd"
      class="c-form"
      :model="fd"
      :inline="true"
      label-position="right"
      label-width="150px"
      label-suffix="："
    >
      <el-row
        class="c-form__row"
      >
        <el-col
          class="c-form__col c-form__part-title"
          :span="24"
        >
          基本信息
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="建筑物"
            prop="jzwMc"
          >
            {{ fd.jzwMc }}
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="楼层"
            prop="lcId"
          >
            {{ fd.lcId }}F
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="检测类别"
            prop="jcdMc"
          >
            {{ fd.jcdMc }}
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="数量"
            prop="jcdSl"
          >
            {{ fd.jcdSl }}
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="具体位置"
            prop="jcdWz"
          >
            {{ fd.jcdWz }}
          </el-form-item>
        </el-col>

        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="备注"
            prop="bz"
          >
            {{ fd.bz }}
          </el-form-item>
        </el-col>
      </el-row>

      <div
        class="o-part-title"
      >
        <span
          class="u-mg-r-10"
        >
          检测结论
        </span>
      </div>
      <k-table
        ref="kTable"
        :table-column="tableColumn"
        :data="fd.jcjlList"
        :pagination="page"
        :pagination-show="false"
      >
        <template
          #jcxBh="scope"
        >
          <el-link
            type="primary"
            @click="handleDialog('view', {id: scope.row.id})"
          >
            {{ scope.row.jcxBh }}
          </el-link>
        </template>
        <template
          #jcjg="scope"
        >
          <span
            :class="{
              'u-text-success' : scope.row.jcjg==='HG',
              'u-text-danger' : scope.row.jcjg!=='HG'
            }"
          >
            {{ scope.row.jcjg==='HG' ? '合格' : (scope.row.jcjg && scope.row.jcjg!=='W'? '不合格' : '无') }}
          </span>
        </template>
      </k-table>

      <div
        class="o-part-title"
      >
        <span
          class="u-mg-r-10"
        >
          检测图片
        </span>
      </div>
      <!-- <div class="o-pgwt">
        <el-image
          v-for="(item,index) in fd.jctp"
          :key="index"
          :preview-src-list="fd.jctp"
          class="o-pgwt__img"
          :src="item"
        />
      </div> -->

      <image-upload-list
        v-model="fd.fjIdList"
        multiple
        disabled
        list-type="picture-card"
      />
    </el-form>

    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="closeDialog()"
      />
    </div>
  </el-dialog>
</template>

<script>
import { jcdService } from './jcd.service';
export default {
  name: 'JcdViewDialog',
  props: {
    xmid: {
      type: String,
      default: ''
    },
    dlParams: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data () {
    return {
      loading: false, // 页面loading计划年份
      dialogShow: true, // 模态框dialog显示
      sbList: [], // 设备名称列表

      /* 表单参数 Start */
      fd: {
        jzwMc: null, // 建筑物
        lcId: null, // 楼层
        jcdMc: 0, // 检测类别
        jcdSl: null, // 数量
        jcdWz: null, // 具体位置
        jcjl: [], // 检测项完成状态
        fjIdList: [], // 检测图片
        bz: null // 备注
      },
      /* 表单参数 End */

      /* 查询结果 Start */
      page: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      },
      /* 查询结果 End */

      /* 表格列配置Start */
      tableColumn: [
        // { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'jcxBh', label: '检测点编号', align: 'left', width: '100', type: 'text' },
        { key: 'jcxMc', label: '检测点', align: 'left', minWidth: '200', type: 'text' },
        { key: 'jcjg', slotName: 'jcjg', label: '检测结果', align: 'center', width: '100', type: 'text' }
      ]
      /* 表格列配置End */
    };
  },
  computed: {

  },
  methods: {

    /**
     * @description: 获取详情
     * @return {*}
     */
    getInfo () {
      const _this = this;
      _this.loading = true;

      jcdService.getJcdInfo(_this.dlParams.id)
        .then(rsp => {
          this.fd = rsp.data.data;
          this.page.rows = Object.assign({}, this.page.rows, rsp.data.jcjl);
        })
        .catch(err => {
          console.error('获取设备详情错误！', err);
          this.loading = false;
        }).finally(() => {
          this.loading = false;
        });
    },

    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    }
  },
  created () {
    this.getInfo();
  }
};
</script>

<style lang="scss">
.o-pgwt {
  display: flex;
  align-content: stretch;
}

.o-pgwt__img {
  width: 100px;
  height: 100px;
  object-fit: cover;
  cursor: pointer;

  & + .o-pgwt__img{
    margin-left: 10px;
  }
}
</style>
